<template>
  <div class="addtestpaper">
    <div class="content">
      <el-form :model="examForm" :rules="rules" ref="examForm" label-width="140px" class="demo-ruleForm">

        <el-form-item :label="$t('Education.languages46')" prop="examTitle">
          <el-input v-model="examForm.examTitle" :disabled="isNew==2?true:false" maxlength="20" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="试卷类型" prop="examType">
          <el-radio-group v-model="examForm.examType" @change="changeexamtype" :disabled="isNew==2?true:false">
            <el-radio :label="1">培训考试</el-radio>
            <el-radio :label="2">课程考试</el-radio>
            <el-radio :label="3">章节考试</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="examForm.examType==1" label="所属培训" prop="examRelId">
          <el-select v-model="examForm.examRelId" filterable clearable placeholder="请选择" :filter-method="searchtrain" :disabled="isNew==2?true:false">
            <el-option
              v-for="item in trainList"
              :key="item.trainId"
              :label="item.trainName"
              :value="item.trainId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="examForm.examType==2 || examForm.examType==3" label="所属课程" prop="examRelId">
          <el-select 
          v-model="examForm.examRelId" 
          filterable 
          :filter-method="searchcourse" 
          clearable placeholder="请选择" 
          :disabled="isNew==2?true:false" 
          @change="getchapterlist">
            <el-option
              v-for="item in CourseList"
              :key="item.courseId"
              :label="item.courseName"
              :value="item.courseId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属章节" v-if="examForm.examType==3" prop="examChapterId">
          <el-select v-model="examForm.examChapterId" clearable placeholder="请选择" :disabled="isNew==2?true:false">
            <el-option
              v-for="item in chapterList"
              :key="item.chapterId"
              :label="item.chapterName"
              :value="item.chapterId">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item :label="$t('Education.languages47')" prop="examRetake">
          <el-radio-group v-model="examForm.examRetake" :disabled="isNew==2?true:false">
            <el-radio label="NOT_RETAKE">{{ $t('Education.languages48') }}</el-radio>
            <el-radio label="LIMIT">{{ $t('Education.languages49') }}</el-radio>
            <el-radio label="NOT_LIMIT">{{ $t('Education.languages50') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('Education.languages51')" prop="examSettingType">
          <el-radio-group v-model="examForm.examSettingType" :disabled="isNew==2?true:false">
            <el-radio label="1">{{ $t('Education.languages52') }}</el-radio>
            <el-radio label="2">{{ $t('Education.languages53') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="考试时长" prop="examDuration">
          <el-input v-model="examForm.examDuration" :disabled="isNew==2?true:false" maxlength="20" show-word-limit></el-input><span style="padding-left: 10px;">分钟</span>
        </el-form-item>

        <el-form-item :label="$t('Education.languages54')" required >
          <el-row :span="12"></el-row>
          <el-row :span="12" style="padding:10px 0;">
            <el-col :span="12">
              <el-form-item :label="$t('Education.languages55')" prop="examRadioNum" label-width="40">
                <el-input
                v-if="examForm.examSettingType==1"
                v-model.number="examForm.appointquestion.examRadioNum" 
                :disabled="examForm.examSettingType==1 || isNew==2?true:false" 
                oninput="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                <el-input
                v-else
                v-model.number="examForm.randomquestion.examRadioNum" 
                :disabled="examForm.examSettingType==1 || isNew==2?true:false" 
                oninput="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                {{$t('Education.languages56')}}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="examRadioScore">
                {{$t('Education.languages57')}}<el-input 
                :disabled="isNew==2?true:false" 
                maxlength="2"
                v-model.number="examForm.examRadioScore" 
                oninput ="value=value.replace(/[^\d.]/g,'')" 
                style="width:50px;margin:0 10px;"></el-input>{{$t('Education.languages58')}}
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="examForm.examSettingType==1">
              <el-button type="primary"
              class="question"
              :disabled="isNew==2?true:false" 
              @click="getquestion(1)">添加单选题</el-button>
            </el-col>
          </el-row>

          <el-row :span="12" style="padding:10px 0;">
            <el-col :span="12">
              <el-form-item :label="$t('Education.languages60')" prop="examMultipleNum" label-width="60">
                <el-input
                v-if="examForm.examSettingType==1"
                v-model.number="examForm.appointquestion.examMultipleNum" 
                :disabled="examForm.examSettingType==1 || isNew==2?true:false" 
                oninput ="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                <el-input
                v-else
                v-model.number="examForm.randomquestion.examMultipleNum" 
                :disabled="examForm.examSettingType==1 || isNew==2?true:false" 
                oninput ="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                {{ $t('Education.languages56') }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="examMultipleScore">
                {{$t('Education.languages57')}}<el-input 
                :disabled="isNew==2?true:false" 
                v-model.number="examForm.examMultipleScore" 
                oninput ="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                {{ $t('Education.languages58') }}
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="examForm.examSettingType==1">
              <el-button type="primary" 
              class="question"
              :disabled="isNew==2?true:false" 
              @click="getquestion(2)">添加多选题</el-button>
            </el-col>
          </el-row>

          <el-row :span="12" style="padding:10px 0;">
            <el-col :span="12">
              <el-form-item :label="$t('Education.languages61')" prop="examQuestionNum" label-width="60">
                <el-input 
                v-if="examForm.examSettingType==1"
                v-model.number="examForm.appointquestion.examQuestionNum" 
                :disabled="examForm.examSettingType==1 || isNew==2?true:false" 
                oninput="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                <el-input 
                v-else
                v-model.number="examForm.randomquestion.examQuestionNum" 
                :disabled="examForm.examSettingType==1 || isNew==2?true:false" 
                oninput="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                {{ $t('Education.languages56') }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="examQuestionScore">
                {{ $t('Education.languages57') }}<el-input 
                :disabled="isNew==2?true:false" 
                v-model.number="examForm.examQuestionScore" 
                oninput ="value=value.replace(/[^\d.]/g,'')" 
                maxlength="2"
                style="width:50px;margin:0 10px;"></el-input>
                {{ $t('Education.languages58') }}
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="examForm.examSettingType==1">
              <el-button type="primary" 
              class="question"
              :disabled="isNew==2?true:false"  
              @click="getquestion(4)">添加问答题</el-button>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item :label="$t('Education.languages62')" prop="examTotalScore">
          <el-input v-model="examForm.examTotalScore" disabled="disabled"></el-input>
        </el-form-item>

        <el-form-item label="合格分" prop="examPassScore">
          <el-input v-model="examForm.examPassScore" :disabled="isNew==2?true:false" maxlength="4" show-word-limit></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="clickPreview" :loading="iscontinuous">预览试卷</el-button>
          <el-button @click="$router.go(-1)">{{ $t('Education.languages15') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

<!--试卷预览弹窗-->
<el-dialog
  :visible.sync="Previewdialog"
  width="50%">
    <div class="testpaperPreview">
      <h1 class="title">{{examForm.examTitle}}</h1>
      <div class="Testquestions">
        <b class="questionstype">单选题</b>
        <div v-for="(item,index) in ExamPreviewRadio">
          <p class="questionsname">{{index+1}}、{{item.questionTitle}}</p>
          <el-radio-group>
            <el-radio v-for="items in item.answers" disabled>
              <img style="width: 200px;" v-if="items.optionType==2" :src="items.option">
              <span v-else>{{items.option}}</span>
            </el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="Testquestions">
        <b class="questionstype">多选题</b>
        <div v-for="(item,index) in ExamPreviewmultiple">
          <p class="questionsname">{{index+1}}、{{item.questionTitle}}</p>
          <el-checkbox-group >
            <el-checkbox v-for="items in item.answers" disabled>{{ items.option }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="Testquestions">
        <b class="questionstype">问答题</b>
        <div v-for="(item,index) in ExamPreviewanswers">
          <p class="questionsname">{{index+1}}、{{item.questionTitle}}</p>
          <p class="QAtext">{{item.answers[0].option}}</p>
        </div>
      </div>
      <div style="margin:30px auto;text-align: center;">
        <el-button type="primary" @click="submitForm('examForm')" :disabled="isNew==2?true:false">{{ $t('Education.languages14') }}</el-button>
        <el-button @click="Previewdialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>

    

    <!-- 选择题目弹窗 -->
    <el-drawer
      title="选择考题"
      :visible.sync="examdrawer"
      size="60%">
      <div style="margin:0 5% 20px;">
        <el-button type="primary" @click="joinexamclick">加入试题</el-button>
        <el-button type="primary" @click="examdrawer=false">返回</el-button>
      </div>
      <el-table 
      v-show="questionParam.questionType==1"
      ref="multipleTable" 
      :data="questionData" 
      @selection-change="handleSelectionChange" 
      :row-key="row=>row.questionId"
      style="width: 90%;margin: auto;">
        <el-table-column type="selection" :reserve-selection="true"></el-table-column>
        <el-table-column prop="courseName" label="课程"></el-table-column>
        <el-table-column prop="chapterName" label="章节"></el-table-column>
        <el-table-column prop="questionTitle" label="题目"></el-table-column>
        <el-table-column prop="type" label="题型"></el-table-column>
        <el-table-column prop="createBy" label="录入人"></el-table-column>
        <el-table-column prop="createTime" label="录入时间"></el-table-column>
      </el-table>
      
      <el-table 
      v-show="questionParam.questionType==2"
      ref="multipleTable2" 
      :data="questionData2" 
      @selection-change="handleSelectionChange2" 
      :row-key="row=>row.questionId"
      style="width: 90%;margin: auto;">
        <el-table-column type="selection" :reserve-selection="true"></el-table-column>
        <el-table-column prop="courseName" label="课程"></el-table-column>
        <el-table-column prop="chapterName" label="章节"></el-table-column>
        <el-table-column prop="questionTitle" label="题目"></el-table-column>
        <el-table-column prop="type" label="题型"></el-table-column>
        <el-table-column prop="createBy" label="录入人"></el-table-column>
        <el-table-column prop="createTime" label="录入时间"></el-table-column>
      </el-table>

      <el-table 
      v-show="questionParam.questionType==4"
      ref="multipleTable4" 
      :data="questionData4" 
      @selection-change="handleSelectionChange4" 
      :row-key="row=>row.questionId"
      style="width: 90%;margin: auto;">
        <el-table-column type="selection" :reserve-selection="true"></el-table-column>
        <el-table-column prop="courseName" label="课程"></el-table-column>
        <el-table-column prop="chapterName" label="章节"></el-table-column>
        <el-table-column prop="questionTitle" label="题目"></el-table-column>
        <el-table-column prop="type" label="题型"></el-table-column>
        <el-table-column prop="createBy" label="录入人"></el-table-column>
        <el-table-column prop="createTime" label="录入时间"></el-table-column>
      </el-table>
      <el-pagination
        hide-on-single-page
        @current-change="handleCurrentChange"
        :current-page.sync="questionParam.pageNum"
        :page-size="questionParam.pageSize"
        layout="total, prev, pager, next"
        :total="questionParam.pageTotal">
      </el-pagination>
    </el-drawer>

  </div>
</template>
<script>
export default ({
  name:'addtestpaper',
  data(){
    return{
      iscontinuous:false,
      rules: {
        examTitle: [{ required: true, message:'请输入试卷标题', trigger: 'blur' }],
        examType: [{ required: true, message:'请选择内容', trigger: 'change' }],
        examRelId:[{ required: true, message:'请选择内容', trigger: 'change' }],
        examChapterId:[{ required: true, message:'请选择所属章节', trigger: 'change' }],
        examRetake: [{ required: true, message:'请选择不合格重考配置', trigger: 'change' }],
        examSettingType:[{ required: true, message:'请选择试卷配置方式', trigger: 'blur' }],
        examDuration:[{ required: true, message:'请输入考试时长', trigger: 'blur' }],
        examRadioNum:[{ required: true, message: this.$t('Education.languages63')+this.$t('Education.languages64'), trigger: 'blur' }],
        examRadioScore:[{ required: true, message: this.$t('Education.languages63')+this.$t('Education.languages65'), trigger: 'blur' }],
        examMultipleNum:[{ required: true, message: this.$t('Education.languages63')+this.$t('Education.languages64'), trigger: 'blur' }],
        examMultipleScore:[{ required: true, message: this.$t('Education.languages63')+this.$t('Education.languages65'), trigger: 'blur' }],
        examQuestionNum:[{ required: true, message: this.$t('Education.languages63')+this.$t('Education.languages64'), trigger: 'blur' }],
        examQuestionScore:[{ required: true, message: this.$t('Education.languages63')+this.$t('Education.languages65'), trigger: 'blur' }],
        examTotalScore:[{ required: true, message: '请输入总分', trigger: 'blur' }],
        examPassScore:[{ required: true, message: '请输入合格分数', trigger: 'blur' }],
      },
      examTotal:0,
      examForm: {
        examId:'',
        examTitle: '',
        examType:1,
        examRelId:'',
        examChapterId:'',
        examRetake:'',
        examDuration:'',
        examRetakeNum:'',
        examSettingType:'',
        examRadioNum:0,
        examRadioScore:2,
        examMultipleNum:0,
        examMultipleScore:3,
        examQuestionNum:0,
        examQuestionScore:10,
        examTotalScore:'',
        examPassScore:0,
        questionIds:[],
        randomquestion:{
          examRadioNum:0,
          examMultipleNum:0,
          examQuestionNum:0,
        },
        appointquestion:{
          examRadioNum:0,
          examMultipleNum:0,
          examQuestionNum:0,
        }
      },
      trainList:[],
      chapterList:[],
      CourseList:[],
      isNew:'',
      Preview:false,
      ExamPreviewRadio:[],
      ExamPreviewmultiple:[],
      ExamPreviewanswers:[],
      radio:'000',
      issubmitstatu:false,
      Previewdialog:false,
      // 培训条件
      paramstrain:{
        pageNum:1,
        pageSize:10,
        searchValue:''
      },
      // 课程条件
      paramscourse:{
        pageNum:1,
        pageSize:10,
        courseName:''
      },
      

      // 考题弹窗
      examdrawer:false,
      questionData:[],
      questionData2:[],
      questionData4:[],
      dialogradioData:[],
      dialogmultipleData:[],
      dialoganswersData:[],
      questionParam:{
        pageNum:1,
        pageSize:10,
        pageTotal:0,
        questionType:'',
        chapterId:'',
        courseId:''
      },
    }
  },
  computed:{
    examTotalScore(){
      if(this.examForm.examSettingType==1){//自定义出题
        this.examForm.examTotalScore=this.examForm.appointquestion.examRadioNum*this.examForm.examRadioScore+this.examForm.appointquestion.examMultipleNum*this.examForm.examMultipleScore+this.examForm.appointquestion.examQuestionNum*this.examForm.examQuestionScore;
      }else{//随机出题
        this.examForm.examTotalScore=this.examForm.randomquestion.examRadioNum*this.examForm.examRadioScore+this.examForm.randomquestion.examMultipleNum*this.examForm.examMultipleScore+this.examForm.randomquestion.examQuestionNum*this.examForm.examQuestionScore;
      }
      this.examForm.examPassScore=Math.ceil(this.examForm.examTotalScore*0.6);
      this.issubmitstatu=false;
      return this.examForm.examTotalScore
    }
  },
  watch:{
    examTotalScore(newval,oldval){
      this.examForm.examTotalScore=newval;
      if(newval!=this.examTotal){
        this.examForm.examPassScore=Math.ceil(this.examForm.examTotalScore*0.6);
      }
    },
  },
  activated() {
    this.examForm.examId=this.$route.query.examId;
    this.examForm.examRelId='';
    this.isNew=this.$route.query.isNew;
    if(this.isNew!=0){
      this.examDetail();
    }else{
      this.initexamtype(this.examForm.examType);
    }
    
  },
  methods:{ 
    // 查询详情
    examDetail(){
      this.$Http_Get('/edu/exam/getInfo/'+this.$route.query.examId).then(res=>{
        if(res.Code==0){
          this.examForm['examId']=res.Data.examId;
          this.examForm['examTitle']=res.Data.examTitle;
          this.examForm['examRadioScore']=res.Data.examRadioScore;
          this.examForm['examMultipleScore']=res.Data.examMultipleScore;
          this.examForm['examQuestionScore']=res.Data.examQuestionScore;
          this.examForm['examRetake']=res.Data.examRetake;
          this.examForm['examSettingType']=res.Data.examSettingType;
          this.examForm['examType']=parseInt(res.Data.examType);
          this.examForm['examRetakeNum']=res.Data.examRetakeNum;
          this.examForm['examRelId']=res.Data.examRelId?res.Data.examRelId:'';
          this.examForm['examChapterId']=res.Data.examChapterId;
          this.examForm['examDuration']=res.Data.examDuration;
          this.examForm['examSettingType']=res.Data.examSettingType.toString();
          this.examForm['questionIds']=[];
          this.initexamtype(this.examForm.examType);
          this.echosubject(res);
        }else{  
          this.$message({type: 'error', message:'获取详情失败'});
        }
      })
    },

    // 初始化加载列表
    initexamtype(e){
      if(e==1){
        this.gettrainlist();
      }else if(e==2){
        this.getcourselist();
      }else{
        this.getcourselist();
        this.getchapterlist();
      }
    },

    // 回显试卷列表
    echoexamlist(res){
      var _this=this;
      _this.dialogRadioData=[];
      _this.dialogmultipleData=[];
      _this.dialoganswersData=[];
        for(let item of res.Data.questions){
          if(item.questionType==1){
            _this.ExamPreviewRadio.push(item);
            _this.examForm['examSettingType']==1?_this.dialogRadioData.push(item):[]
          }else if(item.questionType==2){
            _this.ExamPreviewmultiple.push(item);
            this.examForm['examSettingType']==1?_this.dialogmultipleData.push(item):[]
          }else{
            _this.ExamPreviewanswers.push(item);
            this.examForm['examSettingType']==1?_this.dialoganswersData.push(item):[];
          }
        }
      this.Preview=true;
    },

    // 回显试卷配置
    echosubject(res){
      this.examForm.examRadioNum=res.Data.examRadioNum;
      this.examForm.examMultipleNum=res.Data.examMultipleNum;
      this.examForm.examQuestionNum=res.Data.examQuestionNum;
      if(res.Data.examSettingType==1){
        this.examForm.appointquestion.examRadioNum=res.Data.examRadioNum;
        this.examForm.appointquestion.examMultipleNum=res.Data.examMultipleNum;
        this.examForm.appointquestion.examQuestionNum=res.Data.examQuestionNum;
      }else{
        this.examForm.randomquestion.examRadioNum=res.Data.examRadioNum;
        this.examForm.randomquestion.examMultipleNum=res.Data.examMultipleNum;
        this.examForm.randomquestion.examQuestionNum=res.Data.examQuestionNum;
      }
      this.echoexamlist(res);
    },

    // 查询培训列表
    gettrainlist(){
      this.$Http_Post('edu/train/list',this.paramstrain).then(res=>{
        if(res.Code==0){
          this.trainList=res.Data;
          // this.examForm.examRelId=this.examForm.examRelId=='' && res.Data.length>0?res.Data[0].trainId:this.examForm.examRelId;
        }else{
          this.$message({type: 'error', message:'无法获取培训列表'});
        }
      })
    },

    // 查询课程列表
    getcourselist(){
      this.$Http_Post('edu/course/list',this.paramscourse).then(res=>{
        if(res.Code==0){
          this.CourseList=res.Data;
        }else{
          this.$message({type: 'error', message:'无法获取课程列表'});
        }
      })
    },

    // 查询章节列表
    getchapterlist(){
        this.$Http_Post('edu/chapter/list',{courseId:this.examForm.examRelId}).then(res=>{
          if(res.Code==0){
            this.chapterList=res.Data;
          }else{
            this.$message({type: 'error', message:'无法获取章节列表'});
          }
        })
    },


    // 选择试卷类型 培训考试、课程考试、章节考试
    changeexamtype(e){
      this.examForm.examRelId='';
      if(parseInt(this.examForm['examType'])==1){
        this.examForm.examChapterId=''
        this.gettrainlist();
      }else if(parseInt(this.examForm['examType'])==2){
        this.examForm.examChapterId=''
        this.getcourselist();
      }else{
        this.getcourselist();
        this.getchapterlist();
      }
    },

    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 提交
    submitForm(formName) {
      var _this=this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.iscontinuous = true
          if(this.ExamPreviewRadio.length<=0 && this.ExamPreviewmultiple.length<=0 && this.ExamPreviewanswers.length<=0){
            this.$message({type: 'error', message:"试卷内容为空，请重新选择并生成"});
            return false;
          }
          _this.examForm.examRadioNum=this.ExamPreviewRadio.length;
          _this.examForm.examMultipleNum=this.ExamPreviewmultiple.length;
          _this.examForm.examQuestionNum=this.ExamPreviewanswers.length;
          if(this.issubmitstatu){
            _this.examForm.examRetakeNum=this.examForm.examRetake=='NOT_RETAKE'?'0':this.examForm.examRetake=='LIMIT'?'1':'-1';
            let Url=_this.isNew==0?'edu/exam/add':'edu/exam/edit';
            _this.$Http_Post(Url,this.examForm).then(res=>{
              _this.iscontinuous = false;
              _this.Previewdialog=false;
              if(res.Code==0){
                this.examForm.examId='';
                this.examForm.examTitle='';
                this.examForm.examType=1;
                this.examForm.examRelId='';
                this.examForm.examChapterId='';
                this.examForm.examRetake='';
                this.examForm.examDuration='';
                this.examForm.examRetakeNum='';
                this.examForm.examSettingType='';
                this.examForm.questionIds=[];
                this.examForm.examTotalScore=0;
                this.examForm.examPassScore=0;
                this.examForm.randomquestion.examRadioNum=0
                this.examForm.randomquestion.examMultipleNum=0
                this.examForm.randomquestion.examQuestionNum=0
                this.examForm.appointquestion.examRadioNum=0
                this.examForm.appointquestion.examMultipleNum=0
                this.examForm.appointquestion.examQuestionNum=0
                this.dialogRadioData=[];
                this.dialogmultipleData=[];
                this.dialoganswersData=[];
                this.$refs.examForm.resetFields();
                this.$router.push('/Education/exammanage')
                this.$message({type: 'success', message:res.Message});
              }else{
                this.$message({type: 'error', message:res.Message});
              }
            })
          }else{
            this.$message({type: 'warning', message:"请先填写完整试卷配置并预览"});
            return false;
          }
        } else {
          this.$message({type: 'error', message:"请填写完整信息"});
          return false;
        }
      });
    },

    // 生成试卷前判断指定出题还是随机出题
    Questionmethod(){
      if(this.examForm.examSettingType==1){
        if(this.examForm.appointquestion.examRadioNum>0 || this.examForm.appointquestion.examMultipleNum>0 || this.examForm.appointquestion.examQuestionNum>0){
          this.examForm.examRadioNum=this.examForm.appointquestion.examRadioNum;
          this.examForm.examMultipleNum=this.examForm.appointquestion.examMultipleNum;
          this.examForm.examQuestionNum=this.examForm.appointquestion.examQuestionNum;
          this.ExamPreviewRadio=this.dialogRadioData;
          this.ExamPreviewmultiple=this.dialogmultipleData;
          this.ExamPreviewanswers=this.dialoganswersData;
          for(let item of this.dialogRadioData){
              this.examForm.questionIds.push(item.questionId);
            }
            for(let item of this.dialogmultipleData){
              this.examForm.questionIds.push(item.questionId);
            }
            for(let item of this.dialoganswersData){
              this.examForm.questionIds.push(item.questionId);
            }
            this.issubmitstatu=true;
        }
      }else{
        if(this.ExamPreviewRadio || this.ExamPreviewmultiple || this.ExamPreviewanswers){
          this.examForm.examRadioNum=this.examForm.randomquestion.examRadioNum;
          this.examForm.examMultipleNum=this.examForm.randomquestion.examMultipleNum;
          this.examForm.examQuestionNum=this.examForm.randomquestion.examQuestionNum;
            for(let item of this.ExamPreviewRadio){
              this.examForm.questionIds.push(item.questionId);
            }
            for(let item of this.ExamPreviewmultiple){
              this.examForm.questionIds.push(item.questionId);
            }
            for(let item of this.ExamPreviewanswers){
              this.examForm.questionIds.push(item.questionId);
            }
            this.issubmitstatu=true;
          }
      }
    },

    // 点击预览
    clickPreview(){
      this.$refs['examForm'].validate((valid) => {
        if (valid) {
          this.examForm.questionIds=[];
          this.ExamPreviewRadio=[];
          this.ExamPreviewmultiple=[];
          this.ExamPreviewanswers=[];
          if(this.examForm.examSettingType==1){//自定义出题
            if(this.examForm.appointquestion.examRadioNum>0 || this.examForm.appointquestion.examMultipleNum>0 || this.examForm.appointquestion.examQuestionNum>0){
              this.Questionmethod();
              this.issubmitstatu=true;
              this.Previewdialog=true
            }else{
              this.$message({type: 'error', message:"请填写正确的题目数量"});
            }
          }else{//随机出题
            if(this.examForm.randomquestion.examRadioNum>0 || this.examForm.randomquestion.examMultipleNum>0 || this.examForm.randomquestion.examQuestionNum>0){
              if(this.examForm.randomquestion.examRadioNum>0){
                this.getRandomQuestion(1,this.examForm.randomquestion.examRadioNum);
              }
              if(this.examForm.randomquestion.examMultipleNum>0){
                this.getRandomQuestion(2,this.examForm.randomquestion.examMultipleNum);
              }
              if(this.examForm.randomquestion.examQuestionNum>0){
                this.getRandomQuestion(4,this.examForm.randomquestion.examQuestionNum);
              }
              this.issubmitstatu=true;
              this.Previewdialog=true
            }else{
              this.$message({type: 'error', message:"请填写正确的题目数量"});
            }
          }
        }else{
          this.$message({type: 'error', message:"请填写完整信息"});
        }
      })
    },

    // 预览试卷接口
    getRandomQuestion(type,num){
      let data={
        questionType:type.toString(),
        limit:num.toString(),
        examType:this.examForm.examType
      };
      if(this.examForm.examType==2 || this.examForm.examType==1){
        data['courseId']=this.examForm.examRelId.toString();
      };
      if(this.examForm.examType==3){
        data['courseId']=this.examForm.examRelId.toString();
        data['chapterId']=this.examForm.examChapterId.toString()
      }
      this.$Http_Post('edu/question/getRandomQuestion',data).then(res=>{
        if(res.Code==0){
          if(type==1){
            this.ExamPreviewRadio=res.Data;
          }else if(type==2){
            this.ExamPreviewmultiple=res.Data;
          }else if(type==4){
            this.ExamPreviewanswers=res.Data;
          }
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      })
    },

    // 获取考题数据
    getquestion(type){
      this.questionParam.courseId=null;
      this.questionParam.chapterId=null;
      this.questionParam.trainId=null;
      this.questionParam.questionType=type?type:this.questionParam.questionType;
      if(this.examForm.examType==1 && this.examForm.examRelId==''){
        this.$message({type: 'warning', message:"请选择培训考试"});
        return false;
      };
      if(this.examForm.examType==2 && this.examForm.examRelId==''){
        this.$message({type: 'warning', message:"请选择课程考试"});
        return false;
      };
      if(this.examForm.examType==3 && (this.examForm.examChapterId=='' || this.examForm.examRelId=='')){
        this.$message({type: 'warning', message:"请选择课程和章节"});
        return false;
      };
      if(this.examForm.examType==1){
        this.questionParam.trainId=this.examForm.examRelId;
      }else{
        this.questionParam.courseId=this.examForm.examRelId;
        this.questionParam.chapterId=this.examForm.examChapterId;
      }
      this.$Http_Post('edu/question/list',this.questionParam).then(res=>{
        if(res.Code==0){
          this.questionParam.pageTotal=res.Counts;
          this.examdrawer=true;
          if(this.questionParam.questionType==1){
            this.questionData=res.Data;
            this.$nextTick(() => {
              for(let i=0;i<this.examForm.appointquestion.examRadioNum;i++){
                this.$refs.multipleTable.toggleRowSelection(this.$refs.multipleTable.data[i],true);
              }
            })
          }else if(this.questionParam.questionType==2){
            this.questionData2=res.Data;
            this.$nextTick(() => {
              for(let i=0;i<this.examForm.appointquestion.examMultipleNum;i++){
                this.$refs.multipleTable2.toggleRowSelection(this.$refs.multipleTable2.data[i],true);
              }
            })
          }else{
            this.questionData4=res.Data;
            this.$nextTick(() => {
              for(let i=0;i<this.examForm.appointquestion.examQuestionNum;i++){
                this.$refs.multipleTable4.toggleRowSelection(this.$refs.multipleTable4.data[i],true);
              }
            })
          }
          
        }else{
          this.$message({type: 'error',message:"获取考题失败"});
        }
      });
    },

    // 分页
    handleCurrentChange(val){
      this.questionParam.pageNum=val;
      this.getquestion();
    },
    // 加入试题
    joinexamclick(e){
      this.examForm.appointquestion.examRadioNum=this.dialogRadioData?this.dialogRadioData.length:0;
      this.examForm.appointquestion.examMultipleNum=this.dialogmultipleData?this.dialogmultipleData.length:0;
      this.examForm.appointquestion.examQuestionNum=this.dialoganswersData?this.dialoganswersData.length:0;
      this.examdrawer=false;
    },
    // 选择试题
    handleSelectionChange(val){
      this.dialogRadioData=val;
    },
    handleSelectionChange2(val){
      this.dialogmultipleData=val;
    },
    handleSelectionChange4(val){
      this.dialoganswersData=val;
    },

    // 搜索培训考试
    searchtrain(val){
      this.paramstrain.searchValue=val;
      this.gettrainlist();
    },

    // 搜索课程
    searchcourse(val){
      this.paramscourse.courseName=val;
      this.getcourselist();
    },

    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.ExamPreviewRadio=[];
            this.ExamPreviewmultiple=[];
            this.ExamPreviewanswers=[];
            this.issubmitstatu=false;
          })
          .catch(_ => {});
      },

  },
})
</script>
<style>
.addtestpaper{background: #fff;padding:30px;}
.addtestpaper .testpaperPreview{padding: 30px 0;}
.addtestpaper .testpaperPreview .title{font-size: 26px;text-align: center}
.addtestpaper .testpaperPreview .Testquestions .questionstype{font-size:20px;padding-top: 30px;display: block;}
.addtestpaper .testpaperPreview .Testquestions .questionsname{font-size: 16px;padding: 10px 0 5px;}
.addtestpaper .testpaperPreview .Testquestions .item,.testpaperPreview .Testquestions  .QAtext{display: block;padding:5px 0;color:#333;padding-left: 30px;}
.addtestpaper .el-form-item__content{width: 370px;}
.addtestpaper .el-input{width: 80%;}
.addtestpaper .question{position: relative;z-index: 9;}
</style>